"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Analytics_1 = require("../Analytics");
const defaults_1 = require("../defaults");
const autoParams_1 = require("./autoParams");
const paramKeys_1 = require("./paramKeys");
const systemCookie_1 = require("./systemCookie");
const buildHit_1 = require("./tasks/buildHit");
const sendHit_1 = require("./tasks/sendHit");
const timing_1 = require("./tasks/timing");
const TrackerFilters_1 = require("./TrackerFilters");
const TrackerParams_1 = require("./TrackerParams");
class Tracker {
    constructor(api, ...input) {
        this.timing = false;
        this.hasCookie = false;
        this.me = {
            pageview: [paramKeys_1.default.Page],
            event: [paramKeys_1.default.EventCategory, paramKeys_1.default.EventAction, paramKeys_1.default.EventLabel, paramKeys_1.default.EventValue],
            social: [paramKeys_1.default.SocialNetwork, paramKeys_1.default.SocialAction, paramKeys_1.default.SocialTarget],
            timing: [paramKeys_1.default.TimingCategory, paramKeys_1.default.TimingVar, paramKeys_1.default.TimingValue, paramKeys_1.default.TimingLabel],
        };
        this.api = api;
        const config = this.parseCreateArgs(input);
        this.analytics = new Analytics_1.default();
        this.analytics.configure(config);
        this.params = new TrackerParams_1.default();
        this.filters = new TrackerFilters_1.default(this);
        this.setTrackerParam(paramKeys_1.default.ApiVersion, 1);
        this.setTrackerParamWithFilter(paramKeys_1.default.BuildHitTask, buildHit_1.default);
        this.setTrackerParamWithFilter(paramKeys_1.default.SendHitTask, sendHit_1.default);
        this.setTrackerParamWithFilter(paramKeys_1.default.TimingTask, timing_1.default());
        autoParams_1.default.init(this.params);
        this.hasCookie = systemCookie_1.default.init(this.params, this.analytics.config.entityKey || '');
    }
    send(...input) {
        if (input.length > 0) {
            if (input.length === 1 && typeof input[0] === 'object') {
                const action = input[0].hitType;
                if (action) {
                    const args = this.parseSendArgs(this.me[action] || [], input);
                    args[paramKeys_1.default.HitType] = action;
                    this.params.set(args, undefined, !0);
                    this.filters.run(this.params);
                    this.params.data.m = {};
                }
            }
            else {
                const action = input.shift();
                if (action) {
                    const args = this.parseSendArgs(this.me[action] || [], input);
                    args[paramKeys_1.default.HitType] = action;
                    this.params.set(args, undefined, !0);
                    this.filters.run(this.params);
                    this.params.data.m = {};
                }
            }
        }
    }
    set(...input) {
        if (input.length > 0) {
            const key = input.shift();
            const value = input.shift();
            if (key) {
                this.params.set(key, value);
            }
        }
    }
    postData(hitType, hitPayload) {
        this.analytics.send(hitType, hitPayload, this.params.getOrEmpty(paramKeys_1.default.CorellationKey), 'gmp/1');
    }
    setTrackerParam(key, value) {
        this.params.data.set(key, value);
    }
    setTrackerParamWithFilter(key, value) {
        this.setTrackerParam(key, value);
        this.filters.add(key);
    }
    parseCreateArgs(args) {
        if (args.length < 2) {
            throw new Error(`create requires at least 2 args: consumer key and api key`);
        }
        const consumerKey = args[0];
        const apiKey = args[1];
        const entityKey = args.length > 2 ? args[2] : '';
        const endpoint = args.length > 3 ? args[3] : defaults_1.default.endpoint;
        return {
            apiKey,
            consumerKey,
            endpoint,
            entityKey,
        };
    }
    parseSendArgs(allowedArgs, args) {
        if (1 === args.length && null != args[0] && 'object' === typeof args[0]) {
            return args[0];
        }
        const parsedArgs = {};
        for (let d = Math.min(allowedArgs.length + 1, args.length), e = 0; e < d; e++) {
            if ('object' === typeof args[e]) {
                for (const g in args[e]) {
                    if (g) {
                        args[e].hasOwnProperty(g) && (parsedArgs[g] = args[e][g]);
                    }
                }
                break;
            }
            else {
                e < allowedArgs.length && (parsedArgs[allowedArgs[e]] = args[e]);
            }
        }
        return parsedArgs;
    }
}
exports.default = Tracker;
